import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { IconButton, Icon, Panel } from 'rsuite'
import ActivityProductivityForm from './ActivityProductivityForm'
import ActivityProductivityTable from './ActivityProductivityTable'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import {
  getActivityProduct,
  saveActivityProduct,
  updateActivityProduct,
  deleteActivityProduct,
} from '../../../../redux/actions/budget'
import { startLoading, doneLoading } from '../../../../utils/loading'
import WarningMessage from '../../../../components/message/WarningMessage/WarningMessage'
import { getSchemaSidebar } from '../../../../redux/actions/sidebar'

export default function ActivityProductivityWidget({ projectVersionId, ...props }) {
  const dispatch = useDispatch()
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const {
    showCommandButton,
    showCommandButtonAc,
    onBackToViewAcBudgetForm,
    isEditAll,
    bordered,
    shaded,
    collapsible,
    expanded,
    defaultExpanded,
    activityId,
    forceEdit,
  } = props
  const [section, setSection] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [panelExpanded, setPanelExpanded] = useState(props.schema.values.length > 0 ? true : false)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = projectVersionId || sessionStorage.getItem('projectId')

  // useEffect(() => {
  //   console.log('props.schema', props.schema)
  //   if(props.schema.values.length > 0){
  //     console.log('length', props.schema.values.length)
  //     setPanelExpanded(true)
  //   }
  // }, [props.schema])

  // useEffect(() => {
  //   setPanelExpanded(expanded)
  // }, [expanded])

  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  const handleUpdateSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setIsDeleteError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateActivityProduct(projectId, activityId, request)
      } else {
        console.log('call save.')
        response = await saveActivityProduct(projectId, activityId, request)
      }
      if (response) {
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (schama) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setIsDeleteError(false)
    try {
      console.log('call delete.')
      const status = await deleteActivityProduct(projectId, activityId, schama.id)
      if (status === 200) {
        console.log('call get.')
        const _schema = await getActivityProduct(projectId, activityId)
        setFormSchema(_schema)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    let request = {
      id: data.selectedId,
      projectVersionId: projectId,
      userId: 'string',
      projectActivityId: activityId,
      productType: data.productType,
      productDescription: data.productDescription,
      quantity: data.quantity,
      unitOfMeasure: data.unitOfMeasure,
    }

    console.log('request', request)

    handleUpdateSave(request)
  }

  const onDelete = (index) => {
    let dataList = [...formSchema.values]
    handleDelete(dataList[index])
  }

  const onBackToView = () => {
    console.log('onBackToView', formSchema.value)

    setFormSchema((state) => ({
      ...state,
    }))
    setIsEdit(!isEdit)
    setIsError(false)
    setIsDeleteError(false)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  return (
    <Panel
      header={formSchema.header}
      shaded={shaded}
      bordered={bordered}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginTop: -45 }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {(isEdit && showCommandButton) || forceEdit ? (
        <ActivityProductivityForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          onSubmit={handleSubmit(onSubmit)}
          onDelete={onDelete}
          isError={isError}
          isDeleteError={isDeleteError}
          loading={isLoading}
        />
      ) : (
        <>
          <ActivityProductivityTable schema={formSchema} />
        </>
      )}

      {/* {console.log(showCommandButton, isEdit)} */}
      {showCommandButtonAc && (
        <>
          <hr />
          <div>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-info"
              icon={<Icon className="bt-gost-icon-radius-info" icon="backward" />}
              onClick={(e) => {
                onBackToViewAcBudgetForm(true)
              }}
            >
              {`ดูรายการกิจกรรม`}
            </IconButton>
          </div>
        </>
      )}

      {showCommandButton && (
        <>
          <hr />
          {isEdit ? (
            <div>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-info"
                icon={<Icon className="bt-gost-icon-radius-info" icon="backward" />}
                onClick={onBackToView}
              >
                {`ดูรายการ${formSchema.buttonText ? formSchema.buttonText : ''}`}
              </IconButton>
            </div>
          ) : (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-edit"
              onClick={() => {
                console.log(!isEdit)
                setIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              icon={<Icon className="bt-gost-icon-radius-edit" icon="edit" />}
            >
              {`เพิ่ม/แก้ไข'${formSchema.buttonText ? formSchema.buttonText : ''}`}
            </IconButton>
          )}
        </>
      )}
    </Panel>
  )
}
